<div class="dialog-cron">
  <h2>Cron</h2>
  <div class="inner">
    <div>
      <div>
        <label for="transitTimeValue">TransitTimeValue <app-popover [message]="help_messages.transit_time"></app-popover></label>
        <br>
        <select id="transitTimeValue" class="pure-input-2-3" style="width: 80%; height: 23px; margin-bottom: 5px" [(ngModel)]="transitTimeValue">
          <option *ngFor=" let _transitTimeValue of transitTimeValueOptions; let i = index " [value]="_transitTimeValue" >
            {{ _transitTimeValue }}
          </option>
        </select>
      </div>
      <div>
        <label for="threshold">Threshold<app-popover [message]="help_messages.threshold"></app-popover></label>
        <br>
        <input type="range" min="0" max="100" class="pure-input-2-3 pure-form pure-form-stacked" id="threshold"  [(ngModel)]="threshold" style="width: 80%; height: 23px; margin-bottom: 5px" />
        <input
          class="form-control mb-4 ng-untouched ng-pristine ng-valid"
          readonly
          name="cronForm"
          [(ngModel)]="threshold">
      </div>
    </div>
    <label>Cron Expression<app-popover [message]="help_messages.cron_value"></app-popover></label>
    <div class="inner-quartz-cron">
      <quartz-cron [(ngModel)]="cronExpression" [activeTab]="activeTab" [tabs]="tabs" cssClassPrefix="custom-quartz-cron-"></quartz-cron>
      <input
        class="form-control mb-4 ng-untouched ng-pristine ng-valid"
        readonly
        name="cron"
        [value]=getInHumanReadableForm()>
    </div >
    <button class="pure-button pure-button-primary button-large mat-raised-button" (click)="submitCronValue()"> Submit </button>
  </div>
  <button (click)="closeEvent()" aria-label="Close" class="dialog__close-btn close-button"><i class="fa fa-times">close</i></button>
</div>
<div class="overlay" ></div>
